var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistogram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 4.24998C10.75 3.83577 10.4142 3.49998 10 3.49998C9.58579 3.49998 9.25 3.83577 9.25 4.24998V16.75C9.25 17.1642 9.58579 17.5 10 17.5C10.4142 17.5 10.75 17.1642 10.75 16.75V4.24998Z",
    fill: "#FFA800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.50002C15.4142 8.50002 15.75 8.8358 15.75 9.25002V16.75C15.75 17.1642 15.4142 17.5 15 17.5C14.5858 17.5 14.25 17.1642 14.25 16.75V9.25002C14.25 8.8358 14.5858 8.50002 15 8.50002Z",
    fill: "#FFA800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.5C5.41421 11.5 5.75 11.8358 5.75 12.25V16.75C5.75 17.1642 5.41421 17.5 5 17.5C4.58579 17.5 4.25 17.1642 4.25 16.75V12.25C4.25 11.8358 4.58579 11.5 5 11.5Z",
    fill: "#FFA800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistogram);
export default __webpack_public_path__ + "static/media/histogram.e909cb10.svg";
export { ForwardRef as ReactComponent };